import { $InternalStudent } from "@store/internal-study/students-store";
import { $Title } from "@store/title-store";
import { StudentShortDataT } from "@interfaces/internal-study/students";

import { HeaderPropsT, MenuBurgerIconsPropsT } from "@interfaces/common";
import { Link, useNavigate } from "react-router-dom";
import { concatClientUrl } from "@utils/api-tools";
import { useRef, useState } from "react";

import AuthService from "@services/auth-service";
import Loader from "@ui/indicators/loader";
import { Title } from "@components/common/common";
import clsx from "clsx";
import logo from "@assets/images/header-logo.png";
import style from "@scss/components/header.module.scss";
import { useOnClickOutside } from "@hooks/useOnClickOutside";
import { useUnit } from "effector-react";
import { useQueryClient } from "react-query";

const MenuBurgerIcons: React.FC<MenuBurgerIconsPropsT> = ({
  menuDisplay,
  onBurgerClick,
}) => {
  if (menuDisplay) {
    return (
      <svg
        className={clsx(style.menu_burg)}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onBurgerClick}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    );
  }

  return (
    <svg
      className={clsx(style.menu_burg)}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onBurgerClick}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
};

const Header: React.FC<HeaderPropsT> = (props) => {
  const student = useUnit($InternalStudent) as StudentShortDataT;
  const title = useUnit($Title);
  const queryClient = useQueryClient();

  const [accountPanelDisplay, setAccountPanelDisplay] =
    useState<boolean>(false);
  const history = useNavigate();

  const menuPanelRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuPanelRef, () => {
    setAccountPanelDisplay(false);
  });

  const handleLogout = () => {
    AuthService.logout(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("type");
      queryClient.clear();
      history("/login");
    });
  };

  return (
    <header className={clsx(style.header)}>
      <div className={clsx(style.header_cont)}>
        <MenuBurgerIcons {...props} />
        <div className={clsx(style.right_side)}>
          <div className={clsx(style.logo)}>
            <Link to={"/"}>
              <img src={logo} alt="OT" className={clsx(style.headerLogoImg)} />
            </Link>
          </div>
          <div className={clsx(style.title)}>
            <Title text={title} />
          </div>
          <div className={clsx(style.header_tariff)}>
            <div
              className={clsx(style.header_account_panel)}
              ref={menuPanelRef}
            >
              <div className={clsx(style.user_small_img_link)}>
                <img
                  src={concatClientUrl("/img/static/dummy-avatar.png")}
                  alt=""
                  className={clsx(style.user_small_img)}
                />
              </div>
              {!student ? (
                <Loader />
              ) : (
                <>
                  <div
                    className={clsx(style.header_panel_wrapper)}
                    onClick={() => {
                      setAccountPanelDisplay(!accountPanelDisplay);
                    }}
                  >
                    <div className={clsx(style.header_user_data)}>
                      <p className={clsx(style.user_name)}>
                        {student.employee_info.name}
                      </p>
                    </div>
                    <img
                      src="/img/static/black-arrow-drop.png"
                      alt=""
                      className={clsx(style.dropdown_arrow)}
                    />
                  </div>
                </>
              )}
              {accountPanelDisplay && (
                <div className={clsx(style.account_dropdown)}>
                  <div className={clsx(style.account_dropdown_cont)}>
                    <div className={clsx(style.user_panel_actions)}>
                      <button
                        className={clsx(style.user_panel_action_item)}
                        onClick={handleLogout}
                      >
                        <img src="/img/static/log-out.png" alt="" />
                        Выйти
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
